import Util from '../common/Util.js';


class App {
    constructor(_option) {
        this.startY = $(window).height() - 200;
        this.scrollMagic = new ScrollMagic.Controller();
        this.setTimelines();
        this.addEvents();
        this.addTimelines();   
    }
    talkpickTab(e){
        this.removeTabsActive();
        this.setTabActive($(e.target));
        this.setImage($(e.target));
    }
    setImage(obj){
        const pannel = obj.attr('data-pannel');
        const target = $('.about4-pannel .img-bns'); 
        const targetDomain = target.attr('src').split('/img/about/')[0];
        const fileName = (pannel !=='3') ? `section4-graph-screenshot1` : `section4-log-screenshot1`;
        console.log(`${targetDomain}/img/about/${fileName}.jpg`)
        target.attr('src', `${targetDomain}/img/about/${fileName}.jpg` );
    }
    removeTabsActive(){
        $('.about-tab-item').removeClass('is-active');
        $('[class^="about4-pannel-item"]').removeClass('is-active');
    }
    setTabActive(obj){
        const pannel = obj.attr('data-pannel');
        obj.addClass('is-active');
        $('.about4-pannel-item' + pannel).addClass('is-active');
    }
    setTimelines(){
        const title = {y: 0, opacity: 1};
        const description = {y: 8, opacity: 1, delay:0.1};

        this.timelines = {
            section1 :  new TimelineMax()
                .to(`.about-section1 .about-title`, .6, title, "end")
                .to(`.about-section1 .about-description`, .6, description, "end") 
                .to(`.section1-pc`, .6, {y: 0, opacity: 1, delay: 0.3}, "end")
                .to(`.section1-m`, .6, {y: 0, opacity: 1, delay: 0.4}, "end")
                .to(`.section1-logo`, .4, {y: 0, opacity: 1, scale: 1, delay: 0.8, ease: Back.easeOut}, "end")
            ,
            section2 :  new TimelineMax()
                .to(`.about-section2 .about-title`, .6, title, "end")
                .to(`.about-section2 .about-description`, .6, description, "end") 
                .to(`.section2-screen1 .img-bns2`, .3, {y: 0, x: 0, z: 0, opacity: 1, delay: 0.4}, "end") 
                .to(`.section2-screen1 .img-bns`, .3, {y: 0, x: 0, z: 0, opacity: 1, delay: 0.6}, "end") 
                .to(`.section2-screen1 .img-sns`, .6, {y: 0, x: 0, z: 0, scale:1, opacity: 1, delay: 0.9, ease: Expo.easeOut}, "end") 
            ,
            section3 :  new TimelineMax()
                .to(`.about-section3 .about-title`, .6, title, "end")
                .to(`.about-section3 .about-description`, .6, description, "end") 
                .to(`.section3-screen1 .img-bns`, .6, {y: 0, x: 0, z: 0, opacity: 1, delay: 0.3}, "end") 
                .to(`.section3-screen1 .img-zoom`, .5, {y: 0, opacity: 1, scale: 1, delay: 0.5, ease: Back.easeOut}, "end")
            ,
            section4 :  new TimelineMax()
                .to(`.about-section4 .about-title`, .6, title, "end")
                .to(`.about-section4 .about-description`, .6, description, "end")
                .to(`.about4-pannel .img-bns`, .6, {y: 0, opacity: 1, delay: 0.3}, "end")
                .to(`.about-section4 .about-tab`, .4, { y: 0, opacity: 1, delay: 0.3}, "end")
                .to(`.about-section4 .about-tooltip`, .5, {opacity: 1, delay: 0.5, ease: Back.easeOut}, "end")
            ,
            section5 :  new TimelineMax()
                .to(`.about-section5 .about-title`, .6, title, "end")
                .to(`.about-section5 .about-description`, .6, description, "end") 
                .to(`.section5-screen1 .img-movie`, .4, {y: 0, opacity: 1, delay: 0.3}, "end")
                .to(`.section5-screen1 .section5-live`, .2, {opacity: 1, delay: 0.3}, "end")
                .to(`.section5-screen1 .img-youtube`, .3, {y: 0, x: 0, z: 0, opacity: 1, delay: 0.5}, "end") 
                .to(`.section5-screen1 .img-twitch`, .6, {y: 0, x: 0, z: 0, opacity: 1, delay: 0.7}, "end") 
        }
    }
    addTimelines(){
        for( let i = 1; i < 6; i++){ //타이틀 & 설명 
            new ScrollMagic.Scene({triggerElement: `.about-section${i}`})
                .setTween(this.timelines[`section${i}`])
                .addTo(this.scrollMagic);
        }

        new ScrollMagic.Scene({triggerElement: `.about-section4`})
            .addTo(this.scrollMagic)
            .on('enter', (e)=> {
                const item = $('.about-tab-item:first-child');
                this.setTabActive(item);
            })
            .on('leave', (e)=> {
                this.removeTabsActive();
            })
    }
    addEvents(){
        $('.about-tab-item').on('click', (e) => this.talkpickTab(e));
    }
}
export default App;

Util.namespace('nc.nctv.about');
nc.nctv.about = App;
